import { useReactiveVar } from "@apollo/client/react";

import { IS_ME_LINK } from "@/constants/app";
import { isWebView } from "@/constants/webView";
import { currentUserVar } from "@/graphql/globalVar/state";

import useBingAnalytics from "./analytics/useBingAnalytics";
import useChatGptAdsPixel from "./analytics/useChatGptAdsPixel";
import useGoogleAnalytics from "./analytics/useGoogleAnalytics";
import useLinkedInInsightTag from "./analytics/useLinkedInInsightTag";
import useNaverAdsPixel from "./analytics/useNaverAdsPixel";
import useRedditPixel from "./analytics/useRedditPixel";
import useYahooAdsPixel from "./analytics/useYahooAdsPixel";
import useHelpCrunch from "./useHelpCrunch";
// import useFacebookPixel from "./analytics/useFacebookPixel";

const isProd = import.meta.env.PROD;

// Reddit, LinkedIn, Bing, ChatGPT and Naver Ads pixels below are configured with
// me-qr-only account IDs, so they must stay off on me-link to avoid mixing
// me-link traffic/conversions into me-qr's ad accounts. Yahoo is not in this
// list — it uses a separate conversion label per site (see subscriptionEvent.ts).
const isMeQrProd = isProd && !IS_ME_LINK;

function GlobalWidgets() {
  const user = useReactiveVar(currentUserVar);

  useHelpCrunch(isProd && !isWebView, user);

  useGoogleAnalytics(isProd);
  useRedditPixel(isMeQrProd);
  useLinkedInInsightTag(isMeQrProd);
  useBingAnalytics(isMeQrProd);
  useChatGptAdsPixel(isMeQrProd);
  useYahooAdsPixel(isProd);
  useNaverAdsPixel(isMeQrProd);
  // useFacebookPixel(isProd);

  return null;
}

export default GlobalWidgets;
